import {flow, types} from 'mobx-state-tree';
import * as api from '../../services/api';
// tslint:disable

const UserModel = types.model('UserModel', {
  id: types.identifierNumber,
  email: types.string,
  firstName: types.string,
  lastName: types.optional(types.string, ''),
  phone: types.optional(types.string, ''),
  countryCode: types.optional(types.string, ''),
  location: types.optional(types.string, ''),
  avatar: types.optional(types.string, ''),
  languages: types.optional(types.string, ''),
  latitude: types.maybe(types.number),
  longitude: types.maybe(types.number),
  reviewByOwner: types.maybe(types.number),
  reviewByGuest: types.maybe(types.number),
  speedResponse: types.maybe(types.number),
  numberListings: types.maybe(types.number),
  experiences: types.maybe(types.string),
  street: types.optional(types.string, ''),
  province: types.optional(types.string, ''),
  gender: types.optional(types.string, 'OTHER'),
  birthDay: types.optional(types.string, ''),
  role: types.maybe(
    types.model({
      id: types.identifierNumber,
      code: types.string,
      name: types.string
    })
  ),
  teams: types.array(
    types.model({
      id: types.identifierNumber,
      name: types.string,
      email: types.optional(types.string, ''),
      avatar: types.optional(types.string, ''),
      domainName: types.optional(types.string, '')
    })
  )
});

const UserDetailModel = types
  .model('UserDetailModel', {
    isLoading: types.optional(types.boolean, false),
    user: types.maybe(UserModel)
  })
  .actions(self => ({
    getUser: flow(function*(userId: number) {
      self.isLoading = true;
      const response = yield api.getUser(userId);
      if (response.status === 200 && response.data) {
        self.user = response.data.user;
      }
      self.isLoading = false;
    }),
    updateUser: flow(function*(userId: number, data: any, callback: any) {
      self.isLoading = true;
      const response = yield api.updateUser(userId, data);
      if (response.status === 200 && response.data) {
        self.user = response.data.user;
        callback(false, 'Update successfully');
      } else {
        callback(true, 'Update failed');
      }
      self.isLoading = false;
    })
  }));

export default UserDetailModel;
export type UserDetailModelType = typeof UserDetailModel.Type;



// WEBPACK FOOTER //
// ./src/models/UserDetailModel/UserDetailModel.ts